// extracted by mini-css-extract-plugin
module.exports = {"was_price":"was-price_was_price__kQNsX","old_price":"was-price_old_price__dfJHs"};